// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3nXCO","title":"InfoRow_title__2H6_4"};